import { UPDATE_DONOR_INFO } from './types'

//Action creator function to return Plain Object containing action with dynamic data
export const updateDonorInfo = (info) => {
   return { type: UPDATE_DONOR_INFO,  payload: info }  //type is a required field
};
